import config from '../config';

const redirectByResponseStatus = (status: Response['status']) => {
  if (status === 401) {
    window.location.assign(
      `${config.loginURL}${encodeURI(window.location.href)}`,
    );
  }
};

export default redirectByResponseStatus;
